// extracted by mini-css-extract-plugin
export default {"container":"index_container__T9CaN","img":"index_img__30w9G","text":"index_text__Gy8xH","btn":"index_btn__wZlEB"};